import React, { useEffect, useMemo, useState, useRef } from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  InputAdornment,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@material-ui/core'
import cn from 'classnames'
import Flex from 'components/Flex'
import { useTranslation } from 'react-i18next'
import SearchIcon from '@material-ui/icons/Search'
import { Pagination } from '@material-ui/lab'
import { useDispatch, useSelector } from 'react-redux'
import { selectFanpageSelected } from 'views/Customer/CustomerSelectors'
import _ from 'lodash'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import EditIcon from '@material-ui/icons/Edit'
import fanpageApi from '../../api/fanpageApi'
import styled from 'styled-components'
import { X } from 'react-feather'
import moment from 'moment'
import TagPreviewItem from 'components/TagPreviewItem'
import LoadingWrapper from '../LoadingWrapper'
import { showError, showSuccess } from '../../stores/alert/slice.alert'
import customerApi from '../../api/customerApi'
import types from '../../constants/types'
import Confirm from 'components/Modals/Confirm'
import useDebounce from '../../hook/useDebouce'
import { ArrowBack } from '@material-ui/icons'
import ButtonComponent from 'components/Button'
import { closeLoading, openLoading } from '../../stores/loading/slice.loading'
import ModalConfirm from 'components/Modals/ModalConfirm'
import styles from '../../views/Tag/TagView.module.scss'

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    marginBottom: '80px',
  },
  table: {
    minWidth: '100%',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  '.pagination': {
    '& .MuiTablePagination-input': {
      width: 70,
    },
  },

  wrapperSearch: {
    position: 'relative',
  },

  buttonIEA: {
    width: '100%',
    // marginTop: 10,
    textAlign: 'left',
    marginRight: '15px',
    padding: '20px 15px 15px 0px',
    position: 'fixed',
    bottom: 60,
    background: '#F6F9FC',
    '& button': {
      marginRight: 15,
    },
  },
  noData: {
    color: 'rgba(0,0,0,.5)',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '24px',
  },
  iconCheck: {
    '& .MuiSvgIcon-root': {
      width: '40',
      height: '40',
    },
  },
  icon: {
    marginLeft: 5,
    cursor: 'pointer',
    '& .MuiSvgIcon-root': {
      width: '40',
      height: '40',
    },
  },
  classTags: {
    '&:last-child': {
      '& span': {
        display: 'none',
      },
    },
  },
  wrapBox: {
    padding: '15px',
    marginBottom: 30,
  },
  inputAdd: {
    width: '100%',
    marginBottom: 15,
  },
  wrapButton: {
    textAlign: 'center',
  },
  buttonLoadMore: {
    border: '0px',
    color: 'var(--primary-color) !important',
    backgroundColor: 'unset',
  },

  witdhSeq: {
    minWidth: '120px',
    width: '4%',
  },

  witdhCheckBox: {
    minWidth: '60px',
    width: '4%',
  },

  witdhUid: {
    minWidth: '160px',
    width: '15%',
    padding: '0 8px !important',
  },

  widthName: {
    minWidth: '160px',
    width: '15%',
    padding: '0 8px !important',
  },

  widthGender: {
    minWidth: '120px',
    width: '6%',
    padding: '0 8px !important',
  },

  widthPhone: {
    minWidth: '160px',
    width: '15%',
    padding: '0 8px !important',
  },

  widthDate: {
    minWidth: '200px',
    width: '15%',
    padding: '0 8px !important',
  },

  widthLinkFB: {
    minWidth: '120px',
    width: '15%',
    padding: '0 8px !important',
  },

  witdhAction: {
    minWidth: '120px',
    width: '4%',
  },

  widthTag: {
    minWidth: '140px',
    width: '15%',
    padding: '12px 8px !important',
  },

  witdhUidErr: {
    minWidth: '140px',
    width: '20%',
    padding: '0 8px !important',
  },

  p0: {
    padding: '0',
    margin: '0',
  },

  heightHeader: {
    height: '52px',
  },

  f600: {
    fontWeight: 600,
  },

  checkBoxPadding: {
    padding: '10px 20px',
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '18px 0 8px',
  },

  closeBtn: {
    color: '#ffffff', // Màu chữ trắng
    backgroundColor: '#dc3545', // Màu nền đỏ để nổi bật
    border: '2px solid #dc3545', // Viền có màu giống nền
    padding: '6px 20px', // Padding cho nút
    borderRadius: '4px', // Đường viền tròn cho nút
    cursor: 'pointer', // Con trỏ chuột khi hover
    margin: '0 36px !important',
    '&:hover': {
      backgroundColor: '#c82333', // Màu nền khi hover (đỏ đậm hơn)
      borderColor: '#bd2130', // Màu viền khi hover
    },
  },
  dialogTitle: {
    position: 'relative',
    paddingRight: '48px',
    margin: 0,
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    padding: '8px',
    marginRight: '8px',
    color: '#637381',
    '&:hover': {
      color: '#212B36',
      backgroundColor: 'rgba(99, 115, 129, 0.08)',
    },
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#637381',
    padding: '8px',
    marginRight: '8px',
    '&:hover': {
      color: '#212B36',
      backgroundColor: 'rgba(99, 115, 129, 0.08)',
      borderRadius: '50%',
    },
  },

  submitBtn: {
    color: 'white', // Màu chữ
    backgroundColor: '#28a745', // Màu nền
    border: '2px solid #28a745', // Viền
    padding: '6px 26px', // Padding cho nút
    borderRadius: '4px', // Đường viền tròn cho nút
    cursor: 'pointer', // Con trỏ chuột khi hover.
    margin: '0 36px !important',
    '&:hover': {
      backgroundColor: '#218838', // Màu nền khi hover
      borderColor: '#1e7e34', // Màu viền khi hover
    },
  },

  numCusInp: {
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },

  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    margin: '12px 0',
    minHeight: '48px',
  },

  container: {
    flex: 1,
    width: '100%',
  },

  paginationBottom: {
    display: 'flex !important',
    justifyContent: 'end !important',
    alignItems: 'center !important',
  },

  buttonLoadMore: {
    alignItems: 'center',
    appearance: 'none',
    backgroundColor: '#fff',
    border: '1px solid #dbdbdb',
    borderRadius: '.375em',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: '#363636',
    cursor: 'pointer',
    display: 'inline-flex',
    fontFamily: `BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    fontSize: '0.8rem',
    height: '1.8em',
    justifyContent: 'center',
    lineHeight: '1.5',
    padding: 'calc(.5em - 1px) 1em',
    position: 'relative',
    textAlign: 'center',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    touchAction: 'manipulation',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%',

    '&:hover': {
      borderColor: '#b5b5b5',
    },
    '&:active': {
      borderColor: '#4a4a4a',
      outline: '0',
    },
    '&:focus': {
      borderColor: '#485fc7',
      outline: '0',
    },
    '&:focus:not(:active)': {
      boxShadow: 'rgba(72, 95, 199, 0.25) 0 0 0 0.125em',
    },
  },

  rowItem: {
    cursor: 'pointer',
  },

  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    padding: '4px 0 !important',
  },
}))
const countRowPerPages = 10

const CustomersInBomBotTagModal = ({ isOpen, handleClose, tag, onCustomersChanged }) => {
  const tagId = tag?.id;
  const tagName = tag?.name;
  const isSysTag = tagName?.startsWith('Chiến-dịch-');
  const { t } = useTranslation()
  const classes = useStyles()
  const pageSelected = useSelector(selectFanpageSelected)
  const [page, setPage] = useState(0)
  const [customerData, setCustomerData] = useState(null)
  const [currentCustomers, setCurrentCustomers] = useState([])
  const [searchVal, setSearchVal] = useState('')
  const [toastMsg, setToastMsg] = useState(null)
  const toastTimer = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [checkedList, setCheckedList] = useState({})
  const [openConfirm, setOpenConfirm] = useState(false)

  const dispatch = useDispatch()

  const getListCustomers = async (page, searchValue = '') => {
    let searchQuery = `pageId==${pageSelected?.id};bombotTags=in=${tagId}`

    if (searchValue.trim()) {
      searchQuery += `;uid|name==${searchValue}`
    }

    return customerApi
      .getListCustomersInTag({
        search: searchQuery,
        page: page,
        size: countRowPerPages,
      })
      .then((res) => {
        setCustomerData(res)
      })
  }

  // useDebounce(
  //   () => {
  //     ;(async () => {
  //       setIsLoading(true)
  //       try {
  //         setPage(0)
  //         if (!searchVal.trim()) {
  //           await getListCustomers(0)
  //           return
  //         }
  //         await getListCustomers(0, searchVal)
  //       } catch (error) {
  //         console.log('error', error)
  //         dispatch(showError('Có lỗi xảy ra khi tìm kiếm'))
  //       } finally {
  //         setIsLoading(false)
  //       }
  //     })()
  //   },
  //   500,
  //   [searchVal]
  // )

  const handleSearch = async () => {
    setIsLoading(true)
    try {
      setPage(0)
      if (!searchVal.trim()) {
        await getListCustomers(0)
        return
      }
      await getListCustomers(0, searchVal)
    } catch (error) {
      console.log('error', error)
      dispatch(showError(t('setting_account.tag_customers_search_error')))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!isOpen || !tagId) return;
    ;(async () => {
      try {
        setIsLoading(true)

        await getListCustomers(page)
      } catch (error) {
        dispatch(showError(t('setting_account.tag_error_generic')))
      } finally {
        setIsLoading(false)
      }
    })()
  }, [tagId, page, isOpen])

  const handleCheckAllTag = (isChecked) => {
    if (isChecked) {
      let checkListTmp = {}
      customerData?.content.forEach((customer) => {
        checkListTmp[customer.uid] = isChecked
      })
      setCheckedList(checkListTmp)
    } else {
      setCheckedList({})
    }
  }

  const handleCheckTag = (isChecked, uid) => {
    let checkListTmp = { ...checkedList }

    if (isChecked) {
      setCheckedList((prev) => ({
        ...prev,
        [uid]: isChecked,
      }))
    } else {
      delete checkListTmp[uid]
      setCheckedList(checkListTmp)
    }
  }

  const handleDelete = async () => {
    if (!pageSelected?.id) return
    setIsLoading(true)
    try {
      dispatch(openLoading())

      const payload = {
        search: `pageId==${pageSelected?.id}`,
        exclude: [],
        include: Object.keys(checkedList),
        bombotTags: [tagId],
      }

      await customerApi.unlinkBombotTag(payload)
      await getListCustomers(0)
      setOpenConfirm(false)
      dispatch(
        showSuccess(
          t('setting_account.tag_delete_customers_success', { count: Object.keys(checkedList).length })
        )
      )
      setCheckedList({})
      if (onCustomersChanged) onCustomersChanged()
    } catch (error) {
      console.log('error', error)
      dispatch(showError(error.message))
    } finally {
      setIsLoading(false)
      dispatch(closeLoading())
    }
  }

  const handleSubmitDelete = () => {
    if (Object.keys(checkedList).length === 0) {
      dispatch(showError(t('setting_account.tag_customers_error_select')))
      return
    }
    setOpenConfirm(true)
  }

  const handleDeleteSearch = () => {
    setSearchVal('')
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleCopyText = (e, text) => {
    if (e) e.stopPropagation()
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(text))
      setToastMsg(t('tag_customers.copy_toast', { id: text }))
      if (toastTimer.current) clearTimeout(toastTimer.current)
      toastTimer.current = setTimeout(() => setToastMsg(null), 2500)
    }
  }

  return (
    <>
      <div className={`${styles.drawerOverlay} ${isOpen ? styles.show : ''}`} onClick={handleClose}></div>
      <div className={`${styles.drawer} ${isOpen ? styles.open : ''}`}>
        <div className={styles.drawerHd}>
          <div className={styles.drawerHdMain}>
            <div className={styles.drawerTagRow}>
              <div className={`${styles.tagChip} ${isSysTag ? styles.tSys : styles.tCustom}`}>
                <svg viewBox="0 0 12 12" fill="none"><path d="M2 2h4l4 4-4 4-4-4V2z"/><circle cx="5" cy="5" r="0.8" fill="currentColor"/></svg>
                <span>{tagName || `Tag ${tagId}`}</span>
              </div>
            </div>
            <div className={styles.drawerMeta}>
              <span><b>{customerData?.totalElements || 0}</b> {t('tag_customers.customers_label')}</span>
              <span className={styles.tagId}>
                ID {tagId}
                <button className={styles.copyBtn} title={t('tag_customers.copy_id_title')} onClick={(e) => handleCopyText(e, tagId)}>
                  <svg viewBox="0 0 12 12" fill="none"><rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/><path d="M2 8V2h6" stroke="currentColor" strokeWidth="1.5"/></svg>
                </button>
              </span>
            </div>
          </div>
          <button className={styles.drawerClose} onClick={handleClose}>
            <svg viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8"/></svg>
          </button>
        </div>

        <div className={styles.drawerToolbar}>
          <div className={styles.searchWrap}>
            <svg viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4.5"/><path d="M13.5 13.5l-3-3"/></svg>
            <input
              className={styles.searchInput}
              type="text"
              placeholder={t('tag_management.customers.search_plh')}
              value={searchVal}
              onChange={(e) => setSearchVal(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
            />
            {searchVal && (
              <button className={`${styles.searchClear} ${styles.show}`} onClick={handleDeleteSearch}>
                <svg viewBox="0 0 10 10" fill="none"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"/></svg>
              </button>
            )}
          </div>
        </div>

        <div className={styles.drawerSelectall}>
          <label>
            <input
              type="checkbox"
              className={styles.cb}
              checked={customerData?.content?.length > 0 && customerData?.content.every((cus) => checkedList[cus.uid])}
              onChange={(e) => handleCheckAllTag(e.target.checked)}
            />
            <span>
              {t('tag_customers.select_all')}
            </span>
          </label>
          {Object.keys(checkedList).length > 0 && (
            <span className={styles.drawerSelCount}>{t('tag_customers.selected_count', { count: Object.keys(checkedList).length })}</span>
          )}
        </div>

        <div className={styles.drawerBody}>
          <LoadingWrapper isOpen={isLoading}>
            {customerData?.content?.length > 0 ? (
              <div className={styles.custList}>
                {customerData.content.map((row, index) => (
                  <div key={index} className={styles.custRow}>
                    <input
                      type="checkbox"
                      className={`${styles.cb} ${styles.custCb}`}
                      checked={checkedList[row.uid] || false}
                      onChange={(e) => handleCheckTag(e.target.checked, row.uid)}
                    />
                    <div className={styles.custAvatar} style={{ background: 'var(--purple)' }}>
                      {row.name ? row.name.charAt(0).toUpperCase() : t('tag_customers.unknown_name').charAt(0)}
                    </div>
                    <div className={styles.custMain}>
                      <div className={styles.custName}>{row.name || t('tag_customers.unknown_name')}</div>
                      <div className={styles.custSub}>
                        <span className={styles.custUid}>{row.uid}</span>
                        <button
                          className={styles.copyBtn}
                          title={t('tag_customers.copy_uid_title')}
                          onClick={(e) => handleCopyText(e, row.uid)}
                        >
                          <svg viewBox="0 0 12 12" fill="none">
                            <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M2 8V2h6" stroke="currentColor" strokeWidth="1.5"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className={styles.custRight}>
                      <span className={styles.genderPill}>
                        {_.upperCase(row.gender) === _.upperCase(types.GENDER.MALE) ? t('update.gender.male') :
                         _.upperCase(row.gender) === _.upperCase(types.GENDER.FEMALE) ? t('update.gender.female') : t('update.gender.other')}
                      </span>
                      {row.lastInboxTime ? (
                        <span className={styles.custTime}>{moment(row.lastInboxTime).format('DD/MM/YYYY')} <span style={{ fontSize: '9px', opacity: 0.6 }}>(inbox)</span></span>
                      ) : (
                        <span className={styles.custTime}>—</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.drawerEmpty}>
                {t('update.no_data')}
              </div>
            )}
          </LoadingWrapper>
        </div>

        <div className={styles.drawerFt}>
          {Object.keys(checkedList).length > 0 ? (
            <>
              <button className={styles.btnPrimaryLg} style={{ background: '#EF4444' }} onClick={handleSubmitDelete}>
                <svg viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5.5 3.5V2h3v1.5M3.5 3.5l.7 8a1 1 0 001 .9h3.6a1 1 0 001-.9l.7-8"/></svg>
                {t('tag_customers.remove_tag_btn', { count: Object.keys(checkedList).length })}
              </button>
              <div className={styles.drawerFtNote}>{t('tag_customers.remove_tag_note')}</div>
            </>
          ) : (
            <div className={styles.tblFooter} style={{ padding: 0 }}>
              <span className={styles.tblCount}>{t('setting_account.tag_customers_total', { count: customerData?.totalElements || 0 })}</span>
              <div className={styles.pagination}>
                <button className={styles.pgBtn} disabled={page === 0} onClick={() => handleChangePage(null, page - 1)}>
                  <svg viewBox="0 0 12 12" fill="none"><path d="M8 2L4 6l4 4"/></svg>
                </button>
                <button className={`${styles.pgBtn} ${styles.on}`}>{page + 1}</button>
                <button className={styles.pgBtn} disabled={page >= Math.ceil((customerData?.totalElements || 0) / countRowPerPages) - 1} onClick={() => handleChangePage(null, page + 1)}>
                  <svg viewBox="0 0 12 12" fill="none"><path d="M4 2l4 4-4 4"/></svg>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Confirm remove customers from tag */}
      {openConfirm && (
        <div
          onClick={() => setOpenConfirm(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(17,24,39,0.45)',
            zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: 16, padding: '28px 28px 24px',
              width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center',
            }}
          >
            <div style={{
              width: 48, height: 48, borderRadius: '50%', background: '#FEE2E2',
              display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4,
            }}>
              <svg viewBox="0 0 24 24" fill="none" style={{ width: 22, height: 22 }}>
                <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" stroke="#991B1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>
              {t('tag_management.confirm_delete_title')}
            </div>
            <div style={{ fontSize: 12.5, color: '#6B7280', lineHeight: 1.6 }}>
              {t('tag_management.confirm_delete_message_3')}{' '}
              <b style={{ color: '#111827' }}>{Object.keys(checkedList).length}</b>{' '}
              {t('tag_management.confirm_delete_message_4')}
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 8, width: '100%' }}>
              <button
                onClick={() => setOpenConfirm(false)}
                style={{
                  flex: 1, padding: 9, border: '1px solid #E5E7EB', background: '#fff',
                  borderRadius: 8, fontSize: 13, fontWeight: 600, color: '#6B7280',
                  cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                {t('common.btn.cancel')}
              </button>
              <button
                onClick={handleDelete}
                style={{
                  flex: 1, padding: 9, border: 'none', background: '#EF4444',
                  borderRadius: 8, fontSize: 13, fontWeight: 700, color: '#fff',
                  cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                {t('common.btn.delete')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Toast Copy */}
      <div className={`${styles.toast} ${toastMsg ? styles.show : ''}`}>
        <svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5l3 3 6-6.5"/></svg>
        {toastMsg}
      </div>
    </>
  )
}

const CellSticky = styled(TableCell)`
  position: sticky;
  background-color: #fff;
  right: -1px;
  z-index: 2;
  box-shadow: -15px 0px 17px -7px #f0eded;
`

export default CustomersInBomBotTagModal
